'use client';

import { ReactNode } from 'react';
import { Button, Input, InputProps } from '@/shared/ui/core';
import { usePasswordInput } from '../lib/use-password-input';


type ComponentProps = InputProps & {
    PasswordStrength?: ReactNode;
    onClear?: () => void;
}

export const PasswordInput = ({
    autoComplete,
    label,
    defaultValue = '',
    value,
    onChange,
    PasswordStrength,
    onClear: onClearProp,
    ...props
}: ComponentProps) => {
    const { inputType, onChangeType, Icon, ClearIcon, value: resolvedValue, onChange: resolvedOnChange, onClear } = usePasswordInput({
        defaultValue,
        value,
        onChange,
        onClear: onClearProp,
    });

    return (
        <>
            <Input
                label={ label ?? 'Password:' }
                autoComplete={ autoComplete || 'current-password' }
                type={ inputType }
                value={ resolvedValue }
                onChange={ resolvedOnChange }
                rightSlot={ (
                    <>
                        <Button
                            tabIndex={ -1 }
                            aria-label="Show password"
                            onClick={ onChangeType }
                            variant="naked"
                        >
                            <Icon size={ 20 }/>
                        </Button>
                        &nbsp;
                        {
                            resolvedValue &&
                            <Button
                                tabIndex={ -1 }
                                aria-label="Clear field"
                                onClick={ onClear }
                                variant="naked"
                            >
                                <ClearIcon size={ 20 }/>
                            </Button>
                        }
                    </>
                ) }
                data-template="password-input"
                { ...props }
            />

            { PasswordStrength }
        </>
    );
};
